import { endOfDay, startOfDay } from 'date-fns'

import { getShiftPlanningsWithinRange } from '../../../entities/ShiftPlanning/ShiftPlanningsService'
import { areIntervalsOverlapping } from '../../../helpers/date'

export const getUserIdsWithOverlappingShiftPlannings = async (
    userIds: string[],
    startDate: Date,
    endDate: Date,
): Promise<Set<string>> => {
    if (! userIds.length) {
        return new Set()
    }

    const shiftPlannings = await getShiftPlanningsWithinRange({
        filter: {
            userIds,
        },
        startDate: startOfDay(startDate),
        endDate: endOfDay(endDate),
        planned: true,
    })

    const overlappingUserIds = shiftPlannings
        .filter(shiftPlanning => shiftPlanning.user && areIntervalsOverlapping(
            { start: shiftPlanning.start, end: shiftPlanning.end.date },
            { start: startDate, end: endDate },
        ))
        .map(shiftPlanning => (shiftPlanning.user as { id: string }).id)

    return new Set(overlappingUserIds)
}
